"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const cards_1 = require("../../../_shared/cards");
const commands_1 = require("../../../_shared/commands");
const AppealTitle_1 = require("../../../_shared/components/AppealTitle");
const DetailsBar_1 = require("../../../_shared/components/DetailsBar");
const CardHelper_1 = require("../../../_shared/utils/CardHelper");
const actions_1 = require("../../actions");
const surveyHelpers_1 = require("../../utils/surveyHelpers");
function SurveyAppealCard(survey, options) {
    var _a;
    const card = CardHelper_1.CardHelper.newCard();
    if (options === null || options === void 0 ? void 0 : options.hideManagementControls) {
        card.addItem((0, AppealTitle_1.AppealTitle)(survey));
    }
    else {
        card.addItem((0, AppealTitle_1.AppealTitleWithManagementMenu)(survey));
    }
    if ((options === null || options === void 0 ? void 0 : options.isEdited) || (options === null || options === void 0 ? void 0 : options.reOpened)) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            weight: adaptivecards_1.TextWeight.Bolder,
            color: adaptivecards_1.TextColor.Good,
            wrap: true,
            text: options.isEdited
                ? (0, surveyHelpers_1.getSurveyEditText)(options.votesInvalidated)
                : (0, surveyHelpers_1.getSurveyReOpenedText)(),
        }));
    }
    if (survey.description) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: survey.description,
            spacing: adaptivecards_1.Spacing.Medium,
            wrap: true,
        }));
    }
    if ((options === null || options === void 0 ? void 0 : options.recipientType) && (options === null || options === void 0 ? void 0 : options.recipientName)) {
        const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container);
        card.addItem(container);
        container.addItem((0, cards_1.getChannelRow)(survey.applicationType, options === null || options === void 0 ? void 0 : options.recipientType, options === null || options === void 0 ? void 0 : options.recipientName));
    }
    if (!(options === null || options === void 0 ? void 0 : options.hideDetailsBar)) {
        const isMeetingRecipient = survey.recipients.some(recipient => recipient.id.includes("meeting_"));
        const _options = isMeetingRecipient
            ? {
                showStatus: false,
                showCloseDate: false,
                detailsJoinString: (_a = options.detailsJoinString) !== null && _a !== void 0 ? _a : "  \n\n ",
                hideOwner: true,
            }
            : Object.assign({ hideOwner: true }, (options.detailsJoinString && {
                detailsJoinString: options.detailsJoinString,
            }));
        card.addItem((0, DetailsBar_1.detailsBar)(survey, _options));
    }
    if (survey.state === "open") {
        card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "Start polly",
            isPrimary: true,
            data: (0, commands_1.takingStartCommand)(survey.id).toTaskFetchCommand(),
        }));
    }
    if (!options.hideAllResultsButton && (survey.state === "open" || survey.state === "closed")) {
        card.addAction((0, actions_1.ViewSurveyResultsAction)(survey.id));
    }
    if (survey.state === "open" && survey.commentsEnabled) {
        card.addAction((0, actions_1.AddCommentAction)(survey));
    }
    return card;
}
exports.SurveyAppealCard = SurveyAppealCard;
//# sourceMappingURL=SurveyAppealCard.js.map